import React from 'react';
import { UsaMapChart } from '@cubeyou-team/hx-charts';
import styled from 'styled-components';

const StyledUnitedStatesMapChart = styled.div`
  width: 100%;
  height: 300px;
`;

const UnitedStatesMapChart = ({ data, onItemClick }) => {
  return (
    <StyledUnitedStatesMapChart>
      <UsaMapChart data={data} onItemClick={onItemClick} />
    </StyledUnitedStatesMapChart>
  );
};

export default UnitedStatesMapChart;
